export interface ICreditHistoryState {
    isLoading: boolean;
    creditHistoryData: ICreditHistoryResponse[];
    isPurchaseDisabled: boolean;
    hasOneTimeReport: boolean;
    hasOneTimeScore: boolean;
    isOneTimeOnlyScore: boolean;
    isOneTimeOnlyReport: boolean;
    isOneTimeReportLatest: boolean;
    oneTimeScoreServiceCode: string;
    oneTimeReportServiceCode: string;
}

export interface ICreditDataState {
    isLoading: boolean;
    creditData: ICreditResponse[];
    hasError: boolean;
    hasErrorCount?: number;
}

export interface IOneTimeCreditState {
    oneTimeCreditData: ICreditResponse;
    purchasedReport: boolean;
    pageViewScore: boolean;
}

export interface IDailyCreditState {
    isLoading: boolean;
    dailyCreditData: ICreditResponse;
}

export const REQUEST_CREDIT_HISTORY = "REQUEST_CREDIT_HISTORY";
export const RECEIVE_CREDIT_HISTORY = "RECEIVE_CREDIT_HISTORT";
export const REQUEST_CREDIT_DATA = "REQUEST_CREDIT_DATA";
export const RECEIVE_CREDIT_DATA = "RECEIVE_CREDIT_DATA";
export const RECEIVE_ONETIME_CREDIT = "RECEIVE_ONETIME_CREDIT";
export const REQUEST_DAILY_CREDIT = "REQUEST_DAILY_CREDIT";
export const RECEIVE_DAILY_CREDIT = "RECEIVE_DAILY_CREDIT";

export interface IRequestCreditHistoryAction {
    type: typeof REQUEST_CREDIT_HISTORY;
    creditHistoryData: ICreditHistoryResponse[];
    isPurchaseDisabled: boolean;
    hasOneTimeReport: boolean;
    hasOneTimeScore: boolean;
    isOneTimeOnlyScore: boolean;
    isOneTimeOnlyReport: boolean;
    isOneTimeReportLatest: boolean;
    oneTimeScoreServiceCode: string;
    oneTimeReportServiceCode: string;
}

export interface IReceiveCreditHistoryAction {
    type: typeof RECEIVE_CREDIT_HISTORY;
    creditHistoryData: ICreditHistoryResponse[];
    isPurchaseDisabled: boolean;
    hasOneTimeReport: boolean;
    hasOneTimeScore: boolean;
    isOneTimeOnlyScore: boolean;
    isOneTimeOnlyReport: boolean;
    isOneTimeReportLatest: boolean;
    oneTimeScoreServiceCode: string;
    oneTimeReportServiceCode: string;
}

export interface IrequestCreditDataAction {
    type: typeof REQUEST_CREDIT_DATA;
}

export interface IReceiveCreditDataAction {
    type: typeof RECEIVE_CREDIT_DATA;
    creditData: ICreditResponse[];
    hasError: boolean;
    hasErrorCount?: number;
}

export interface IReceiveOneTimeCreditAction {
    type: typeof RECEIVE_ONETIME_CREDIT;
    oneTimeCreditData: ICreditResponse;
    purchasedReport: boolean;
    pageViewScore: boolean;
}

export interface IRequestDailyCreditAction {
    type: typeof REQUEST_DAILY_CREDIT;
}

export interface IReceiveDailyCreditAction {
    type: typeof RECEIVE_DAILY_CREDIT;
    dailyCreditData: ICreditResponse;
}

export type CreditHistoryTypes = IRequestCreditHistoryAction | IReceiveCreditHistoryAction;
export type CreditTypes =
    | IrequestCreditDataAction
    | IReceiveCreditDataAction
    | IReceiveOneTimeCreditAction
    | IRequestDailyCreditAction
    | IReceiveDailyCreditAction
    | IRequestDailyCreditAction
    | IReceiveDailyCreditAction;

export interface ICreditHistoryResponse {
    alertID?: string;
    alertCategory?: string;
    alertDate?: string;
    viewedOnDate?: string;
    alertType?: string;
    alertStatus?: string;
    displayName?: string;
    alertDescription?: string;
    monitorTypes?: string;
    titleFields?: string;
    isThreat?: boolean;
    threatDate?: string;
    serviceType?: string;
    alertTitle?: string;
    createdTime?: string;
    resolvedDate?: string;
    serviceCode?: string;
}

export interface ICreditResponse {
    "created-date"?: string;
    "next-update-date": string;
    "next-score-update-date": string;
    "update-date": string;
    "score-update-date": string;
    "expiration-date": string;
    "score-expiration-date": string;
    "credit-score-title": string;
    "credit-score-description": boolean;
    IsIDFUser: boolean;
    scores: IScore[];
    creditReport: ICreditReport;
    IsExpired: boolean;
    IsScoreExpired: boolean;
    "tu-status"?: string;
    "service-code"?: string;
    "score-service-code"?: string;
    IsPastReport: boolean;
}

export interface ICreditReport {
    summary: ISummaryItems[];
    history: IHistory[];
    contactInformation: ICreditorInfo[];
    recentInquiries: IRecentInquiries[];
    personalInformation: IPersonalInformation[];
    addressInformation: IAddressInformation[];
}

export interface IHistory {
    bureau: string;
    accountNumber: string;
    mappingKey: string;
    creditorName: string;
    dateOpened: string;
    dateClosed: string;
    highBalance: number;
    index: number;
    position: number;
    accountStatus: string;
    amountPastDue: number;
    currentBalance: number;
    dateReported: string;
    monthlyPayment: number;
    monthlyHistoryList: IMonthlyHistory[];
}
export interface IMonthlyHistory {
    year: number;
    month: number;
    status: string;
}
export interface IRecentInquiries {
    bureau: string;
    code: string;
    "date-requested": string;
    "inquery-type": string;
    requestor: string;
    index: number;
}
export interface ICreditorInfo {
    bureau: string;
    name: string;
    address: string;
    telephone: string;
    index: number;
}
export interface IScore {
    type: string;
    "inquiry-date": string;
    abbreviation: string;
    "population-rank": number;
    "risk-score": number;
    "factor-text-positive": string;
    "factor-text-negative": string;
    "score-factor-list": string[];
    "score-desc"?: string;
}
export interface ISummaryItems {
    "closed-accounts": number;
    "credit-bureau": string;
    "delinquent-accounts": number;
    id: number;
    "inquiries-last-2-years": number;
    "number-public-records": number;
    "open-accounts": number;
    "total-accounts": number;
    "total-balances": number;
    "total-monthly-payments": number;
}
export interface IPersonalInformation {
    birth: string;
    borrowerName: string;
    bureau: string;
}
export interface IAddressInformation {
    address: string;
    bureau: string;
    order: number;
}

export interface ICreditAuthState {
    isLoading: boolean;
    authData: ICreditAuthResponse;
}

export const REQUEST_CREDIT_AUTH = "REQUEST_CREDIT_AUTH";
export const RECEIVE_CREDIT_AUTH = "RECEIVE_CREDIT_AUTH";

export interface IRequestCreditAuthAction {
    type: typeof REQUEST_CREDIT_AUTH;
}

export interface IReceiveCreditAuthAction {
    type: typeof RECEIVE_CREDIT_AUTH;
    authData: ICreditAuthResponse;
}

export type CreditAuthTypes = IRequestCreditAuthAction | IReceiveCreditAuthAction;

export interface ICreditAuthResponse {
    "status-code": number;
    message: string;
    data: any;
    "auth-status": string;
    "ssn-status": string;
    "dob-status": string;
    isIDFUser: boolean;
}

export const CREDIT_ENROLLMENT_DETAILS = "CREDIT_ENROLLMENT_DETAILS";
export const LOADER_FOR_CREDIT_ENROLLMENT_DETAILS = "LOADER_FOR_CREDIT_ENROLLMENT_DETAILS";

export interface ICreditEnrollmentDetailsState {
    creditEnrollmentDetails: any;
    isCreditEnrollmentDetailsLoaded: boolean;
}

export interface ICreditEnrollmentDetailsAction {
    creditEnrollmentDetails: any;
    type: typeof CREDIT_ENROLLMENT_DETAILS;
}

export interface ILoaderCreditEnrollmentDetailsAction {
    type: typeof LOADER_FOR_CREDIT_ENROLLMENT_DETAILS;
    isCreditEnrollmentDetailsLoaded: boolean;
}

export type CreditEnrollmentActions = ICreditEnrollmentDetailsAction | ILoaderCreditEnrollmentDetailsAction;
